import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/** Case- and accent-insensitive form of a name ("Turbine" matches "turbiné"). */
export function foldTitle(text: string): string {
  // toLowerCase, not toLocaleLowerCase: the same fold in every browser locale (Turkish "I").
  return text.normalize("NFD").replace(/\p{M}/gu, "").toLowerCase();
}

/** Joins class names and lets later Tailwind utilities win over earlier ones. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
